import {injectable} from "inversify";
import {AndroidFullScreen} from "@awesome-cordova-plugins/android-full-screen";
import {App, AppInfo} from '@capacitor/app';
import {GameSoundService} from "@/services/game-sound-service";

@injectable()
export class CapacitorService {

    private gameSoundService: GameSoundService | undefined;

    public init() {
        App.addListener("appStateChange", (appState) => {
            if (this.gameSoundService !== undefined) {
                this.gameSoundService.setSoundMute(!appState.isActive)
            }
        });
    }

    public setGameSoundSource (gameSoundService: GameSoundService) {
        this.gameSoundService = gameSoundService
    }

    public async fullScreen() {
        AndroidFullScreen.isImmersiveModeSupported().then(() => {
            AndroidFullScreen.immersiveMode()
        })
    }

    public getAppInfo(){
        return App.getInfo();
    }
}